import { MenuItem } from "@mui/material";
import moment from "moment";

export const docTransmittalRegisterColumns = (vendors, clients) => [
  {
    accessorKey: "date",
    header: "Date",
    size: 50,
    Cell: ({ row }) => {
      return moment(row.original.createdAt).format("YYYY-MM-DD");
    },
  },
  { accessorKey: "number", header: "Transmittal #", size: 60 },
  {
    accessorKey: "receiverType",
    header: "Receiver",
    size: 10,
    Cell: ({ row }) => (row.original.vendor?.id ? "Vendor" : "Client"),

    muiEditTextFieldProps: ({ row, table }) => ({
      select: true,
      value: row.getValue("receiverType") ?? "",
      onChange: (e) => {
        const newType = e.target.value;

        table.setEditingRow({
          ...row,
          _valuesCache: {
            ...row._valuesCache,
            receiverType: newType,
            receiver: "",
          },
        });
      },
      children: ["Client", "Vendor"].map((type) => (
        <MenuItem key={type} value={type}>
          {type}
        </MenuItem>
      )),
    }),
  },

  {
    accessorKey: "receiver",
    header: "Receiver Name",
    size: 30,
    Cell: ({ row }) => {
      // console.log("row", row.original);

      return row.original.receiverType === "Vendor"
        ? row.original.vendor?.name
        : row.original.customer?.name;
    },
    muiEditTextFieldProps: ({ row }) => {
      const receiverType = row.getValue("receiverType");

      const options = receiverType === "Vendor" ? vendors : clients;

      return {
        select: true,
        value: row.getValue("receiver") ?? "",
        disabled: !receiverType,
        children: options.map((item) => (
          <MenuItem key={item.id} value={item}>
            {item.name}
          </MenuItem>
        )),
      };
    },
  },
  {
    accessorKey: "initiatedBy",
    header: "Initiated By",
    size: 30,
    enableEditing: false,
    Cell: ({ row }) => row.original.user?.name,
  },

  {
    accessorKey: "remarks",
    header: "Remarks",
    size: 30,
  },
];
